import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactStars from 'react-stars';

export default (props) => {

    const {inputProps, onChangeRate, onConfirm, onCancel} = props;

    return (
        <SweetAlert
            show={inputProps.show}
            type={inputProps.type}
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={inputProps.type === 'default' ? true : false}
            confirmBtnText="Отправить"
            cancelBtnText={inputProps.type === 'default' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={inputProps.type === 'default' ? "Оценка исполнителя" : "Отправлено"}
            onConfirm={() => onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                inputProps.type === 'default'
                ?
                <div className="sw-alert__body sw-alert-evaluate">
                    <div className="evaluate__label">Пунктуальность</div>
                    <ReactStars
                        count={5}
                        onChange={(value) => onChangeRate(value, 'punctuality_rate')}
                        size={32}
                        value={inputProps.punctuality_rate}
                        half={false}
                        color2={'#ffd700'}
                        className='evaluate__star' />

                    <div className="evaluate__label">Результат</div>
                    <ReactStars
                        count={5}
                        onChange={(value) => onChangeRate(value, 'result_rate')}
                        size={32}
                        value={inputProps.result_rate}
                        half={false}
                        color2={'#ffd700'}
                        className='evaluate__star' />

                    <div className="evaluate__label">Методология</div>
                    <ReactStars
                        count={5}
                        onChange={(value) => onChangeRate(value, 'methodology_rate')}
                        size={32}
                        value={inputProps.methodology_rate}
                        half={false}
                        color2={'#ffd700'}
                        className='evaluate__star' />
                </div>
                :
                <div className="sw-alert__body">Спасибо за оценку!</div>
            }
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/EvaluateWork.js